var styleDataHash = "f538e01f";
const injectCss = () => {
  var css = `.nAzJg{box-sizing:border-box;display:flex;flex-direction:column;width:162px;z-index:10}[dir] .nAzJg{background-color:#fff}.nAzJg *,.nAzJg :after,.nAzJg :before{box-sizing:inherit}.nAzJg input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.nAzJg{width:100%}}}@container (width < 640px){.nAzJg{width:100%}}.OMZIE{align-items:flex-start;align-items:center;display:flex;flex-direction:column;width:100%}[dir] .OMZIE{padding:8px 0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var DropdownModal_default = {
  "modal": "nAzJg",
  "dropdownModalOptionsWrapper": "OMZIE"
};
export {
  DropdownModal_default as default,
  injectCss
};
//# sourceMappingURL=DropdownModal-scss.js.map
